import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppError } from '@rms/sdk/errors';
import { PageableParam, Paginated } from '@rms/sdk/models';
import { catchError, Observable, throwError } from 'rxjs';

import { Partner } from '../models';
import { PartnerApiService } from './partner-api.service';

@Injectable({
  providedIn: 'root',
})
export class PartnerService {
  private readonly api = inject(PartnerApiService);

  public getPartners(pageable: PageableParam): Observable<Paginated<Partner>> {
    return this.api
      .getPartners(pageable)
      .pipe(
        catchError((error: HttpErrorResponse) => throwError(() => AppError.from(error, 'partners.errors.load-list')))
      );
  }

  public getPartner(partnerId: string): Observable<Partner> {
    return this.api
      .getPartner(partnerId)
      .pipe(
        catchError((error: HttpErrorResponse) =>
          throwError(() =>
            AppError.from(
              error,
              error.status === HttpStatusCode.NotFound ? 'partners.errors.not-found' : 'partners.errors.load'
            )
          )
        )
      );
  }
}
